var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCopyRight = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-424.417 -521.417)" },
                React.createElement("path", { d: "M450.2,536.4c0,6-4.9,10.8-10.8,10.8s-10.8-4.9-10.8-10.8s4.9-10.8,10.8-10.8\n\t\tS450.2,530.4,450.2,536.4L450.2,536.4z" }),
                React.createElement("g", { transform: "translate(447.763 524.483) rotate(90)" },
                    React.createElement("path", { d: "M15.9,4.1c2.2,2.2,2.2,5.7,0,7.9s-5.7,2.2-7.9,0C5.8,9.8,5.8,6.3,8,4.1" }))))));
});
export default IconCopyRight;
//# sourceMappingURL=IconCopyRight.js.map